import { useMemo } from "react";
import "./property1-default1.css";

const Property1Default1 = ({
  property1DefaultPosition,
  property1DefaultTop,
  property1DefaultLeft,
  property1DefaultBorderRadius,
}) => {
  const property1Default1Style = useMemo(() => {
    return {
      position: property1DefaultPosition,
      top: property1DefaultTop,
      left: property1DefaultLeft,
      borderRadius: property1DefaultBorderRadius,
    };
  }, [
    property1DefaultPosition,
    property1DefaultTop,
    property1DefaultLeft,
    property1DefaultBorderRadius,
  ]);

  return (
    <div className="property-1default1" style={property1Default1Style}>
      <div className="property-1default-item" />
      <div className="dised-app-10">diSed App 1.0</div>
      <div className="a-one-stop">{`A one stop solution for all your AI needs. It is an app that generates endless possibilities with AI at a single place. `}</div>
      <div className="gr-mockup">
        <img className="rectangle-icon1" alt="" src="/rectangle1@2x.png" />
        <img className="rectangle-icon2" alt="" src="/rectangle2@2x.png" />
      </div>
    </div>
  );
};

export default Property1Default1;
